<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import {
    getTitle_api
  } from '@/http/api.js'
export default {
  name: 'App',
  beforeDestroy() {
    sessionStorage.clear();
    localStorage.clear();
  },
  mounted() {
    this.getTip()
  },
  methods:  {
    getTip(){
        getTitle_api().then((res) => {
          if (res.meta.status == 10000) {
            sessionStorage.setItem('config',JSON.stringify(res.data))
          }
        })
      },
  }
}
</script>

<style>
#app {
 /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue